// ============================================================================
// FRACTIONAL KNAPSACK - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'fractional-knapsack',
  name: 'Fractional Knapsack',
  category: 'Greedy',
  complexity: {
    time: 'O(n log n)',
    space: 'O(n)'
  },
  description: 'Fractional Knapsack solves the knapsack problem where items can be broken into fractions. Sorts by value-to-weight ratio and greedily selects items until knapsack is full.'
};
export type MetaType = typeof meta;
